import { useGetMerchantAppProductsQuery } from "Api/Queries/Merchants/useGetMerchantAppProductsQuery";
import { useGetOrbitLStatusQuery } from "Api/Queries/Merchants/useGetOrbitLStatusQuery";
import {
  isComgateProductCode,
  PRODUCTS_REQUIRING_FACILITY,
} from "Components/Shared/Merchant/Products/AppProducts/constants";
import { ProductCode, TerminalFinancingModel } from "Infrastructure/Api/Api";

export const useMerchantFacilityInfo = (merchantPublicID?: string) => {
  const {
    data: merchantAppProducts,
    isLoading: isAppProductsLoading,
    isError: isAppProductsError,
  } = useGetMerchantAppProductsQuery(merchantPublicID);

  const isRequired = !!merchantAppProducts?.some((p) =>
    PRODUCTS_REQUIRING_FACILITY.includes(p.productDto.code),
  );

  const hasComgateProduct = !!merchantAppProducts?.some((p) =>
    isComgateProductCode(p.productDto.code),
  );
  // Each count field belongs to its product: physical terminals to Orbit L, licences to SoftPOS.
  const hasOrbitLProduct = !!merchantAppProducts?.some(
    (p) => p.productDto.code === ProductCode.OrbitL,
  );
  const hasSoftPosProduct = !!merchantAppProducts?.some(
    (p) => p.productDto.code === ProductCode.SoftPos,
  );

  const {
    data: orbitLStatus,
    isLoading: isOrbitLStatusLoading,
    isError: isOrbitLStatusError,
  } = useGetOrbitLStatusQuery(merchantPublicID, hasComgateProduct);

  const isHunterFinanced =
    orbitLStatus?.financingModel === TerminalFinancingModel.Hunter;
  const isLoading = isAppProductsLoading || isOrbitLStatusLoading;
  const isError = isAppProductsError || isOrbitLStatusError;

  return {
    isRequired,
    hasComgateProduct,
    hasOrbitLProduct,
    hasSoftPosProduct,
    isHunterFinanced,
    isLoading,
    isError,
  };
};
